<template>
	<div>
		<form class="form-horizontal" @submit.prevent="save">
			<div class="animated fadeIn">
				<b-card>
					<div class="display-table full-width">
						<strong class="card-title">{{$route.meta.label}}</strong>
					</div>
					<div class="d-flex align-items-center mb-4">
						<b-badge class="text-uppercase mb-2 mr-3" :variant="models.status === 'publish' ? 'success' : models.status === 'draft' || models.status === 'reject' ? 'danger' : 'warning'">{{models.status}}</b-badge>
						<p class="mt-2">{{models.category}}</p>
					</div>
					<b-row>
						<ResponseAlert ref="response" />
						<b-col sm="8" class="mb-2">
							<b-form-group v-bind:class="{ 'is-invalid': errors.has('title')}" label="Title">
								<b-form-input v-model="title" v-validate="'required'" data-vv-name="title">
								</b-form-input>
								<div v-if="errors.has('title')">
									<p class="text-danger">{{ errors.first('title') }}</p>
								</div>
							</b-form-group>
							<b-form-group v-bind:class="{ 'is-invalid': errors.has('slug')}" label="Slug">
								<b-form-input v-model="models.slug" v-validate="'required'" data-vv-name="slug" disabled>
								</b-form-input>
								<div v-if="errors.has('slug')">
									<p class="text-danger">{{ errors.first('slug') }}</p>
								</div>
							</b-form-group>

							<div class="my-3" v-if="$route.fullPath.toLowerCase().includes('video')">
								<div class="d-flex justify-content-center">
								</div>

								<div v-if="vars.videoSrc" class="d-flex justify-content-center">
									<video ref="frame" v-if="isMp4" height="240" controls :src="vars.videoSrc">
									</video>
									<iframe ref="frame" v-else width="500" height="340" :src="vars.videoSrc">
									</iframe>
								</div>
								<div>
									<b-button v-if="!vars.videoUrlActive" block class="btn btn-primary text-white" @click="vars.videoUrlActive = !vars.videoUrlActive">
										Add Video URL
									</b-button>
									<div v-else ref="url_yt">
										<b-input-group  class="mt-3">
											<b-form-input placeholder="Insert video url..." v-model="models.video"></b-form-input>
											<b-input-group-append>
												<b-button @click.prevent="getSrcVideo" variant="primary">Show Preview</b-button>
												<b-button variantawait ="outline-danger" @click="vars.videoUrlActive = !vars.videoUrlActive; vars.videoSrc = null; models.video = null;">Cancel</b-button>
											</b-input-group-append>
										</b-input-group>
									</div>
								</div>
							</div>

							<div class="my-3">
								<uploader :value="models.galleries" @get-files="files => models.galleries = files"/>
							</div>

							<b-form-group v-bind:class="{ 'is-invalid': errors.has('description')}" label="Description">
								<Editor @getAdsState="value => vars.isAdsEmbed = value" :embedAds="embedAds" :value.sync="models.description" @input="value => models.description = value"/>
								<div v-if="errors.has('description')">
									<p class="text-danger">{{ errors.first('description') }}</p>
								</div>
							</b-form-group>
						</b-col>
						<b-col sm="4" class="mb-2">
							<div class="image-input">
								<b-img :src="getUrlOfFile(models.thumbnail)" class="mb-2" style="max-height: 160px; border: none"/>
								<b-button class="btn-upload btn-block" @click="$refs.filemanager.show('thumbnail')">
										<i class="fa fa-upload"></i> Upload Thumbnail
								</b-button>
							</div>
							<b-form-group class="mt-3" v-bind:class="{ 'is-invalid': errors.has('thumbnail title')}" label="Thumbnail Title">
								<b-form-input v-model="models.thumbnail_title" v-validate="vars.thumbnailTitleRules" data-vv-name="thumbnail title">
								</b-form-input>
								<div v-if="errors.has('thumbnail title')">
									<p class="text-danger">{{ errors.first('thumbnail title') }}</p>
								</div>
							</b-form-group>
							<b-form-select v-model="models.category_id" :options="masters.categories"></b-form-select>
							<b-form-checkbox
								id="breaking-news"
								class="my-4"
								v-model="models.is_breaking_news"
								name="breaking-news"
								:value="true"
								:unchecked-value="false"
							>
								Breaking News
							</b-form-checkbox>
							<b-form-checkbox
								id="editors-choice"
								class="my-4"
								v-model="models.is_editor_choice"
								name="editors-choice"
								:value="true"
								:unchecked-value="false"
							>
								Editor's Choice
							</b-form-checkbox>
							<b-form-checkbox
								id="top-stories"
								class="my-4"
								v-model="models.is_top_stories"
								name="top-stories"
								:value="true"
								:unchecked-value="false"
							>
								Top Stories
							</b-form-checkbox>
							<div id="datepicker-date-wrapper" class="mb-3">
										<label for="datepicker-date">Date</label>
										<div class="d-flex flex-column">
											<b-form-datepicker
													id="datepicker-date"
													v-model="models.date"
													placeholder="dd/mm/yyyy"
													:date-format-options="{  day: '2-digit',  month: '2-digit', year: 'numeric' }"
													locale="id"
													class="custom-datepicker"
													@input="handleDateChange('date')"
											/>
											<b-form-timepicker
													v-model="time.date"
													placeholder="--:--"
													:hour12="false"
													class="custom-datepicker mt-2"
											/>
										</div>
							</div>
							<div id="datepicker-publishAt-wrapper" class="mb-3">
										<label for="datepicker-publishAt">Publish At</label>
										<div class="d-flex flex-column">
											<b-form-datepicker
													id="datepicker-publishAt"
													v-model="models.publish_at"
													placeholder="dd/mm/yyyy"
													:date-format-options="{  day: '2-digit',  month: '2-digit', year: 'numeric' }"
													:min="vars.minDate"
													locale="id"
													class="custom-datepicker"
													@input="handleDateChange('publish_at')"
											/>
											<b-form-timepicker
													v-model="time.publish_at"
													placeholder="--:--"
													:hour12="false"
													class="custom-datepicker mt-2"
											/>
										</div>
							</div>
							<b-form-textarea
								class="mb-3"
								v-model="models.meta.keyword"
								placeholder="Meta Keyword"
								rows="5"
								max-rows="10"
							></b-form-textarea>
							<b-form-textarea
								class="mb-3"
								v-model="models.meta.description"
								placeholder="Meta Description"
								rows="5"
								max-rows="10"
							></b-form-textarea>
							<b-form-group v-bind:class="{ 'is-invalid': errors.has('tag')}" label="Tag">
								<multiselect
									style="margin-left: -10px"
									class="bg-white"
									tag-placeholder=""
									placeholder="Tag"
									:showPointer="false"
									v-model="masters.tags"
									:hideSelected="true"
									:showNoResults="false"
									:options="masters.tags"
									:multiple="true"
									:taggable="true"
									:closeOnSelect="false"
									@tag="addTag">
								</multiselect>
							</b-form-group>
							<b-form-checkbox
								v-model="models.is_paid"
								:value="true"
								:unchecked-value="false"
								class="mb-3"
							>
								Paid News
							</b-form-checkbox>
							<b-form-checkbox
								id="advertisement"
								class=""
								v-model="vars.isAds"
								name="advertisement"
								:value="true"
								:unchecked-value="false"
							>
								Add Advertisement
							</b-form-checkbox>
							<div v-if="vars.isAds" class="mb-4">
								<b-form-select class="mt-3" v-model="models.advertisement_id" :options="masters.ads"></b-form-select>
								<small v-if="showRequiredAds" class="text-danger text-center">*Please select an advertisement</small>
								<b-form-select class="mt-3" v-model="models.position" :options="masters.ads_position"></b-form-select>
								<small v-if="!showRequiredAds && models.position === 'body' && vars.isAdsEmbed" class="text-danger text-center">*Add the "[ADS]" tag in the description column according to the ad position you want</small>
							</div>
							<b-form-group class="mt-4" v-if="models.status !== 'waiting review' && models.status !== 'reject'">
								<b-form-radio-group
									v-model="models.status"
									name="status"
								>
									<b-form-radio value="publish">Publish</b-form-radio>
									<b-form-radio value="draft">Draft</b-form-radio>
								</b-form-radio-group>
							</b-form-group>
						</b-col>
					</b-row>
					<template #footer>
						<div v-if="models.status === 'waiting review'">
							<b-button class="btn-min-width rounded float-left" @click="updateStatus('publish')" variant="success">Approve</b-button>
							<b-button class="btn-min-width rounded float-left" @click="updateStatus('reject')" variant="danger">Reject</b-button>
						</div>
						<b-button type="button" variant="light" class="btn-min-width rounded float-left" @click="preview = true">
							Preview
						</b-button>
						<b-button :disabled="hasEmbedAds" type="submit" variant="primary" class="btn-min-width rounded float-left">
							Save
						</b-button>
						<b-button type="button" variant="light" class="btn-min-width rounded float-left" @click="$router.push({name: config.uri})">
							Cancel
						</b-button>
					</template>
				</b-card>
			</div>
			<Filemanager ref="filemanager" name="news" @selectMedia="selectMedia"/>
		</form>
		<div v-if="preview">
			<div class="animated fadeIn">
				<b-card class="pb-5">
					<div class="display-table full-width mb-2">
						<strong class="card-title">Preview</strong>
					</div>
				<b-row>
				<ResponseAlert ref="response" />
				<b-col class="mb-2">
					<div class="m-auto" style="width: 40%;">
						<b-img :src="getUrlOfFile(models.thumbnail, true)" rounded fluid class="mb-2"/>
					</div>
					<main class="mt-3">
						<div class="d-flex align-items-center">
							<h2 class="mr-4 mt-2">{{models.title}}</h2>
							<b-badge v-if="models.is_breaking_news" variant="danger">{{models.is_breaking_news && 'BREAKING NEWS'}}</b-badge>
						</div>
						<div class="d-flex align-items-center">
							<b-badge class="text-uppercase mb-2 mr-3" :variant="models.status === 'publish' ? 'success' : models.status === 'draft' || models.status === 'reject' ? 'danger' : 'warning'">{{models.status}}</b-badge>
							<p class="mt-2">{{models.category}}</p>
						</div>

						<h6>{{moment(models.date).format('dddd, DD MMMM YYYY HH:mm')}}</h6>
						<h6>News Type: <span class="text-uppercase">{{models.type}}</span></h6>

						<hr>

						<div v-if="models.galleries.length > 0" class="items-wrapper">
							<div v-for="file, index in models.galleries" :key="index" class="item-wrapper">
								<b-img :src="getUrlOfFile(file.image)" class="mb-2" alt="image-items"/>
							</div>
						</div>

						<div v-if="models.video !== ''" class="items-wrapper">
							<video ref="frame" v-if="isMp4" height="240" controls :src="models.video">
										</video>
							<iframe ref="frame" v-else width="500" height="340" :src="models.video">
							</iframe>
						</div>

						<div id="content" v-html="models.description">
						</div>

					</main>
				</b-col>
				</b-row>
					<template #footer>
						<div class="d-flex justify-content-center">
							<b-button type="button" variant="light" block class="rounded" @click="preview = false">
								Back to Edit
							</b-button>
						</div>
					</template>
				</b-card>
			</div>
		</div>
	</div>
</template>
<script>
	import api from '@/utils/api.js'
	import moment from 'moment'
	import {
		getUrlOfFile,
		str_slug
	} from '@/utils/helpers.js';
	import Editor from '@/components/editor';
	import Filemanager from '@/components/file_manager';
	import ResponseAlert from '@/components/response_alert';
	import getYoutubeId from 'get-youtube-id'
	import Uploader from '../../../components/uploader.vue';

	export default {
		name: 'FormNews',
		components: {
			ResponseAlert,
			Uploader,
			Filemanager,
			Editor
		},
		data() {
			return {
				preview: false,
				config: {
					uri: this.$route.meta.permission.link,
				},
                time: {
                    date: '',
                    publish_at: '',
                },
				models: {
					type: this.$route.meta.type,
					title: '',
					slug: '',
					category_id: null,
					date: '',
					publish_at: '',
					thumbnail_title: '',
					thumbnail: '',
					galleries: [],
					video: '',
					description: '',
					is_breaking_news: false,
                    is_editor_choice: false,
					is_contributor_news: false,
                    is_top_stories: false,
					meta: {
							description:"",
							keyword: "",
							tag:""
					},
					status: "publish",
					advertisement_id: null,
					position: '',
					is_paid: false
				},
				editorOption: {
					modules: {
						toolbar: [
              ['bold', 'italic', 'underline', 'strike'],
              [{ 'header': 1 }, { 'header': 2 }],
              [{ 'list': 'ordered'}, { 'list': 'bullet' }],
              ['link', 'image'],
              ['clean']
						],
					}
				},
				masters: {
					categories: [
						{
							value: null,
							text: 'Select Category'
						}
					],
					ads: [
						{
							value: null,
							text: 'Select Advertisement'
						}
					],
					ads_position: [
						{
							value: '',
							text: 'Ads Position'
						},
						{
							value: 'popup',
							text: 'Popup'
						},
						{
							value: 'banner',
							text: 'Banner'
						},
						{
							value: 'body',
							text: 'Body'
						},
						{
							value: 'footer',
							text: 'Footer'
						},
						{
							value: 'giant_banner',
							text: 'Giant Banner'
						},
					],
					tags: []
				},
				vars: {
					FormData: new FormData(),
					role_password: 'required|min:8',
					thumbnailTitleRules: '',
					videoSrc: null,
					videoUrlActive: false,
					isAds: false,
					minDate: moment().format('YYYY-MM-DDTHH:mm'),
					embedAdsProps: false,
					isAdsEmbed: false
				},
				moment
			}
		},
		watch: {
			thumbnail() {
				this.vars.thumbnailTitleRules = this.thumbnail === '' ? '' : 'required'
			}
		},
		created() {
			let _ = this
			Promise.all([
				_.getById(),
				_.getAds(),
				_.getCategories()
			]).then(() => {
				this.$watch('ads', () => {
					this.vars.embedAdsProps = this.models.advertisement_id && this.models.position === 'body'
				})
			})
		},
		methods: {
			getById() {
				const _ = this;
				if (_.$route.params.id) {
					_.vars.minDate = ''
					_.$axios.get(`${api.news}/${_.$route.params.id}`)
						.then(res => {
							const { data } = res.data;
							_.models.type = data.type
							_.models.title = data.title
							_.models.slug = data.slug
							_.models.thumbnail_title = data.thumbnail_title
							_.models.category_id = data.category_id
							_.models.date = moment(data.date).format('YYYY-MM-DD')
                            _.time.date = moment(data.date).format('HH:mm')
							_.models.publish_at = moment(data.publish_at).format('YYYY-MM-DD')
                            _.time.publish_at = moment(data.publish_at).format('HH:mm')
							_.models.thumbnail = data.thumbnail
							_.models.galleries = data.galleries
							_.models.video = data.video || ''
							_.models.description = data.description
							_.models.is_breaking_news = data.is_breaking_news
							_.models.is_editor_choice = data.is_editor_choice
							_.models.is_top_stories = data.is_top_stories
							_.models.is_paid = data.is_paid
							_.models.is_contributor_news = data.is_contributor_news
							_.models.status = data.status

							if(Object.entries(data.meta).length > 0) {
								_.models.meta.description = data.meta.description || ''
								_.models.meta.keyword = data.meta.keyword || ''
								_.masters.tags = data.meta.tag === '' ? [] : data.meta.tag.split(",")
							}

							if(data.news_advertisement) {
								_.vars.isAds = true
								_.models.advertisement_id = data.news_advertisement.advertisement_id,
								_.models.position = data.news_advertisement.position
							}

							if(_.models.video) {
								_.vars.videoUrlActive = true
								_.getSrcVideo()
							}
						}).catch(() => _.$router.push({
							name: 'page404'
						}));
				}
			},
			getCategories() {
				const _ = this
				_.$axios.get(api.news_category, {
					params: {
						per_page: 30,
						status: 'active',
						orderby: 'name',
						sort: 'asc',
					}
				}).then(res => {
					const {rows} = res.data.data
					rows.forEach(row => {
						_.masters.categories.push({
							value: row.id,
							text: row.name
						})
					})
				});
			},
			getAds() {
				const _ = this
				_.$axios.get(api.advertisement, {
					params: {
						status: 'publish',
						orderby: 'name',
						sort: 'asc',
					}
				}).then(res => {
					const {rows} = res.data.data
					rows.forEach(row => {
						_.masters.ads.push({
							value: row.id,
							text: row.name
						})
					})
				});
			},
			selectMedia(field, media) {
				const _ = this;
				_.models[field] = media.file;
				_.models[`${field}_title`] = media.title
			},
			getUrlOfFile(file) {
				return getUrlOfFile(file, true);
			},
			getSrcVideo() {
				const fileUrl = this.models.video
				if(fileUrl.toLowerCase().includes('youtube.com')) {
					this.vars.videoSrc = 'https://www.youtube.com/embed/' + getYoutubeId(this.models.video)
				} else {
					this.vars.videoSrc = this.models.video
				}
			},
			addTag (newTag) {
				this.masters.tags.push(newTag)
			},
			async rebuildHomepagePositionAfterSave() {
				try {
					// 1. Get all news
					const newsRes = await this.$axios.get(`${api.news}/all`);
					const hasBreakingNews = newsRes.data.data || false;

					console.log(hasBreakingNews);

					// const hasBreakingNews = newsList.some(n => n.meta && n.meta.breaking === true);

					// 2. Get current homepage position
					const positionRes = await this.$axios.get(api.setting_position, {
						params: {
							type: 'homepage',
						},
					});

					const homepagePositions = positionRes.data || [];

					const newsBlocks = homepagePositions.data.position.filter(p => p.type === 'news');
					const adBlocks = homepagePositions.data.position.filter(p => p.type === 'advertisement');

					// 3. Modify "breaking_news" visibility and rebuild order
					let updatedNewsBlocks = [];

					const hasBreaking = hasBreakingNews > 0;

					if (hasBreaking) {
						// show breaking, latest, top, others
						newsBlocks.forEach(block => {
							if (block.data === 'breaking_news') block.is_show = true;
						});

						const priorityOrder = ['breaking_news', 'latest_news', 'top_stories'];
						priorityOrder.forEach(type => {
							const found = newsBlocks.find(p => p.data === type);
							if (found) updatedNewsBlocks.push(found);
						});

						newsBlocks
						.filter(p => !priorityOrder.includes(p.data))
						.forEach(p => updatedNewsBlocks.push(p));

					} else {
						// hide breaking, show top first, then others
						newsBlocks.forEach(block => {
							if (block.data === 'breaking_news') block.is_show = false;
						});

						const priorityOrder = ['top_stories'];
						priorityOrder.forEach(type => {
							const found = newsBlocks.find(p => p.data === type);
							if (found) updatedNewsBlocks.push(found);
						});

						newsBlocks
						.filter(p => !priorityOrder.includes(p.data))
						.forEach(p => updatedNewsBlocks.push(p));
					}

					// 4. Build payload
					const positionPayload = {
						type: 'homepage',
						ref_id: 0,
						position: [...updatedNewsBlocks, ...adBlocks].map((item, i) => ({
						name: item.name,
						type: item.type,
						data: item.data,
						is_show: item.is_show,
						position: i + 1,
						})),
					};

					// 5. Save position
					await this.$axios.post(api.setting_position, positionPayload);

					// if (this.$refs.responsePosition) {
					// 	this.$refs.responsePosition.setResponse('Homepage position updated successfully.', 'success');
					// }

				} catch (err) {
					if (this.$refs.responsePosition) {
						// this.$refs.responsePosition.setResponse('Failed to update homepage position.', 'danger');
					}
				}
			},
			save() {
				const _ = this;
				_.$validator.validate().then(valid => {
					if (valid) {
						let request = "";
						let message = "create"

						_.models.meta.tag = _.masters.tags.join(',')

						if(!this.vars.isAds) {
							this.models.advertisement_id = null
							this.models.position = ''
						}

                        _.models.date = this.formatedDate('date')
                        _.models.publish_at = this.formatedDate('publish_at')

						if (!_.$route.params.id) {
							request = _.$axios.post(api.news, _.models);
						} else {
							message = "update"
							request = _.$axios.put(`${api.news}/${_.$route.params.id}`, _.models);
						}

						request
							.then(() => {
								this.$showToast('Success', `Success ${message} news`)

								this.rebuildHomepagePositionAfterSave().then(() => {
									_.$router.push({ name: _.config.uri });
								});

								// _.$router.push({
								// 	name: _.config.uri
								// })
							})
							.catch(error => _.$refs.response.setResponse(error.response.data.message, 'danger'));
					} else {
						window.scrollTo(0, 0);
					}
				});
			},
			handleDateChange(type) {
					if (!this.$route.params.id) {
						this.time[type] = moment().format('HH:mm:ss');
					}
			},
			formatedDate(type) {
					if (this.models[type]) {
						const datePart = moment(this.models[type]).format('YYYY-MM-DD');
						const timePart = moment(this.time[type], 'HH:mm').format('HH:mm');
						return `${datePart}T${timePart}`;
					}
					return ''
			},
			updateStatus(status) {
				// this.$axios.put(`${api.news}/set_status/${this.$route.params.id}`, {status})
				// 	.then(res => {
				// 		this.$refs.response.setResponse(res.data.message, 'success');
				// 		this.getById()
				// 	}).catch(error => {
				// 		this.$refs.response.setResponse(error.response.data.message, 'danger')
				// 	})
				this.models.status = status; // Set the status before saving
    			this.save();
			},
		},
		computed: {
			isMp4(){
				return this.vars.videoSrc.substring(this.vars.videoSrc.lastIndexOf(".") + 1) === 'mp4'
			},
			title: {
				get(){
					return this.models.title
				},
				set(value){
					this.models.title = value
					this.models.slug = str_slug(value)
				}
			},
			thumbnail() {
				return this.models.thumbnail
			},
			embedAds () {
				return this.vars.embedAdsProps
			},
			ads() {
				return `${this.models.position} ${this.models.advertisement_id}`
			},
			showRequiredAds() {
				return !this.embedAds && this.models.position === 'body'
			},
			hasEmbedAds() {
				if(this.vars.isAds && this.models.position === 'body') {
					return this.vars.isAdsEmbed || !this.models.advertisement_id || !this.models.description.includes('[ADS]')
				}
				return false
			}
		}
	}
</script>
